import { Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';

const TermsPage = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const sections = [
    {
      title: "Acceptance of Terms",
      content: [
        "By accessing and using Residency Companion, you accept and agree to be bound by the terms and provision of this agreement.",
        "If you do not agree to abide by the above, please do not use this service.",
        "These terms apply to all visitors, users, and others who access or use the service.",
        "We reserve the right to update and change these Terms of Service without notice."
      ]
    },
    {
      title: "Description of Service",
      content: [
        "Residency Companion is a platform that provides personalized residency program recommendations for medical students and graduates.",
        "Our service includes AI-powered matching algorithms, program databases, and educational guidance tools.",
        "We provide information and recommendations based on data analysis, but do not guarantee admission to any program.",
        "The service is intended for informational and educational purposes only."
      ]
    },
    {
      title: "User Account and Registration",
      content: [
        "You must provide accurate, current, and complete information during the registration process.",
        "You are responsible for safeguarding the password and all activities under your account.",
        "You must notify us immediately of any unauthorized use of your account.",
        "We reserve the right to refuse service, terminate accounts, or cancel orders at our sole discretion.",
        "You must be at least 18 years old to use this service."
      ]
    },
    {
      title: "User Conduct and Responsibilities",
      content: [
        "You agree not to use the service for any unlawful purpose or to solicit others to unlawful acts.",
        "You agree not to attempt to gain unauthorized access to our systems or networks.",
        "You will not transmit any worms, viruses, or code of a destructive nature.",
        "You will not use the service to harass, abuse, or harm others.",
        "You are responsible for the accuracy of information you provide to us."
      ]
    },
    {
      title: "Intellectual Property Rights",
      content: [
        "The service and its original content, features, and functionality are owned by Residency Companion and are protected by copyright, trademark, and other laws.",
        "You may not reproduce, distribute, modify, or create derivative works of our content without permission.",
        "Our trademarks and trade dress may not be used without our written permission.",
        "You retain ownership of content you submit, but grant us license to use it for service provision."
      ]
    },
    {
      title: "Payment and Billing",
      content: [
        "Some features of our service require payment of fees.",
        "All fees are non-refundable except as required by law or as specifically stated in our refund policy.",
        "You authorize us to charge your chosen payment method for fees.",
        "We may change our fees at any time with reasonable notice.",
        "Failure to pay fees may result in suspension or termination of your account."
      ]
    },
    {
      title: "Disclaimers and Limitations",
      content: [
        "The information provided is for educational purposes only and should not be considered as professional medical or career advice.",
        "We do not guarantee the accuracy, completeness, or usefulness of any information on the service.",
        "We make no warranties about the reliability, availability, or ability of the service to meet your needs.",
        "Your use of the service is at your own risk.",
        "We are not responsible for decisions made based on information provided through our service."
      ]
    },
    {
      title: "Limitation of Liability",
      content: [
        "In no event shall Residency Companion be liable for any indirect, incidental, special, consequential, or punitive damages.",
        "Our total liability shall not exceed the amount paid by you for the service in the 12 months preceding the claim.",
        "Some jurisdictions do not allow limitation of liability, so these limitations may not apply to you.",
        "We are not liable for any failure or delay in performance due to circumstances beyond our reasonable control."
      ]
    },
    {
      title: "Termination",
      content: [
        "We may terminate or suspend your account and access to the service immediately, without prior notice.",
        "You may terminate your account at any time by contacting us.",
        "Upon termination, your right to use the service will cease immediately.",
        "All provisions which by their nature should survive termination shall survive.",
        "Termination will not limit any of our rights or remedies at law or in equity."
      ]
    },
    {
      title: "Governing Law and Dispute Resolution",
      content: [
        "These Terms shall be interpreted and governed by the laws of the State of New York.",
        "Any dispute arising from these terms shall be resolved through binding arbitration.",
        "Arbitration will be conducted by a single arbitrator in accordance with applicable rules.",
        "The arbitration will take place in New York, NY, unless otherwise agreed.",
        "You waive any right to a jury trial or to participate in a class action lawsuit."
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-sm border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
<Link to="/" className="flex items-center">
<img 
  src="/images/logo.png" 
  alt="Residency Companion Logo" 
  className="w-10 h-10 mr-4 object-contain"
/>
  <h1 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
    Residency Companion
  </h1>
</Link>
            <div className="flex items-center space-x-1">
              <button className="text-gray-600 hover:text-gray-900 px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:bg-gray-50">
                Sign In
              </button>
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-xl">
                Get Started
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative pt-24 pb-16 overflow-hidden bg-gradient-to-br from-blue-50 via-white to-teal-50">
        <div className="absolute inset-0">
          <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob-enhanced"></div>
          <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-teal-100 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-blob-enhanced animation-delay-2000"></div>
        </div>
        
        <div className={`relative z-10 text-center px-6 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="max-w-4xl mx-auto">
            <h1 className="text-5xl md:text-6xl font-thin text-gray-900 mb-6 leading-tight">
              Terms of
              <br />
              <span className="bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent font-light">
                Service
              </span>
            </h1>
            
            <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-3xl mx-auto font-light leading-relaxed">
              Please read these terms carefully before using our platform
            </p>

            <div className="bg-white/70 backdrop-blur-sm border border-gray-200 rounded-lg p-4 inline-block">
              <p className="text-sm text-gray-600">
                <strong>Last Updated:</strong> January 26, 2025
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Terms Content */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          
          {/* Introduction */}
          <div className="mb-16">
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-6">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Agreement Overview</h2>
              <p className="text-gray-700 leading-relaxed">
                These Terms of Service ("Terms") govern your use of the Residency Companion platform and services. 
                By using our service, you agree to these terms. Please read them carefully as they contain important 
                information about your rights and obligations. If you have any questions about these terms, please 
                contact us before using the service.
              </p>
            </div>
          </div>

          {/* Terms Sections */}
          <div className="space-y-12">
            {sections.map((section, index) => (
              <div 
                key={index} 
                className={`transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
                style={{ transitionDelay: `${index * 100}ms` }}
              >
                <h2 className="text-3xl font-semibold text-gray-900 mb-6 border-b border-gray-200 pb-3">
                  {index + 1}. {section.title}
                </h2>
                <div className="space-y-4">
                  {section.content.map((item, itemIndex) => (
                    <div key={itemIndex} className="flex items-start space-x-3">
                      <div className="w-2 h-2 bg-blue-600 rounded-full mt-2 flex-shrink-0"></div>
                      <p className="text-gray-700 leading-relaxed">{item}</p>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Additional Information */}
          <div className="mt-16 space-y-8">
            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Important Notice</h3>
              <p className="text-gray-700 leading-relaxed">
                Residency Companion provides educational tools and information to assist in residency program selection. 
                We do not guarantee admission to any program, and our recommendations should be considered alongside 
                advice from official medical education counselors and advisors. All decisions regarding residency 
                applications remain your responsibility.
              </p>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Changes to Terms</h3>
              <p className="text-gray-700 leading-relaxed">
                We reserve the right to modify these Terms of Service at any time. We will provide notice of material 
                changes by posting the updated terms on our website and updating the "Last Updated" date. Your continued 
                use of the service after such changes constitutes acceptance of the new terms.
              </p>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">Severability</h3>
              <p className="text-gray-700 leading-relaxed">
                If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited 
                or eliminated to the minimum extent necessary so that the Terms will otherwise remain in full force and 
                effect and enforceable.
              </p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mt-16 bg-gradient-to-r from-blue-50 to-teal-50 border border-blue-200 rounded-lg p-8">
            <h3 className="text-2xl font-semibold text-gray-900 mb-4">Questions About These Terms?</h3>
            <p className="text-gray-700 mb-6 leading-relaxed">
              If you have any questions about these Terms of Service, please contact our legal team:
            </p>
            <div className="space-y-2 text-gray-700">
              <div><strong>Email:</strong> legal@residencycompanion.com</div>
              <div><strong>Address:</strong> 123 Medical Drive, Suite 100, New York, NY 10001</div>
              <div><strong>Phone:</strong> +1 (555) 123-4567</div>
            </div>
            <div className="mt-6">
              <button className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-medium transition-all duration-300 hover:scale-105">
                Contact Legal Team
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-50 border-t border-gray-100">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-6">
<img 
  src="/images/logo.png" 
  alt="Residency Companion Logo" 
  className="w-12 h-12 mr-4 object-contain"
/>
                <div>
                  <h4 className="text-2xl font-bold bg-gradient-to-r from-blue-600 to-teal-600 bg-clip-text text-transparent">
                    Residency Companion
                  </h4>
                  <p className="text-sm text-gray-500 font-medium">Medical College Guidance Platform</p>
                </div>
              </div>
              <p className="text-gray-600 font-light">
                Your partner in medical education decisions.
              </p>
            </div>
<div>
  <h5 className="font-semibold text-gray-900 mb-4">Product</h5>
  <ul className="space-y-3 text-gray-600">
    <li><Link to="/features" className="hover:text-blue-600 transition-colors">Features</Link></li>
    <li><Link to="/how-it-works" className="hover:text-blue-600 transition-colors">How It Works</Link></li>
    <li><Link to="/api" className="hover:text-blue-600 transition-colors">API</Link></li>
  </ul>
</div>
<div>
  <h5 className="font-semibold text-gray-900 mb-4">Support</h5>
  <ul className="space-y-3 text-gray-600">
    <li><Link to="/help" className="hover:text-blue-600 transition-colors">Help Center</Link></li>
    <li><Link to="/contact" className="hover:text-blue-600 transition-colors">Contact Us</Link></li>
    <li><Link to="/refund-policy" className="hover:text-blue-600 transition-colors">Refund Policy</Link></li>
    <li><Link to="/cancellation-policy" className="hover:text-blue-600 transition-colors">Cancellation Policy</Link></li>
    <li><Link to="/privacy" className="hover:text-blue-600 transition-colors">Privacy</Link></li>
    <li><Link to="/terms" className="text-blue-600 font-medium">Terms</Link></li>
  </ul>
</div>
<div>
  <h5 className="font-semibold text-gray-900 mb-4">Company</h5>
  <ul className="space-y-3 text-gray-600">
    <li><Link to="/about" className="hover:text-blue-600 transition-colors">About</Link></li>
  </ul>
</div>
          </div>
          <div className="border-t border-gray-200 mt-12 pt-8 text-center">
            <p className="text-gray-500 text-sm">
              © 2025 Residency Companion. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      <style>{`
        @keyframes blob-enhanced {
          0% { transform: translate(0px, 0px) scale(1) rotate(0deg); }
          25% { transform: translate(20px, -30px) scale(1.05) rotate(5deg); }
          50% { transform: translate(-15px, 10px) scale(0.95) rotate(-3deg); }
          75% { transform: translate(25px, -20px) scale(1.08) rotate(7deg); }
          100% { transform: translate(0px, 0px) scale(1) rotate(0deg); }
        }
        .animate-blob-enhanced { animation: blob-enhanced 9s ease-in-out infinite; }
        .animation-delay-2000 { animation-delay: 2s; }
      `}</style>
    </div>
  );
};

export default TermsPage;